import { render, staticRenderFns } from "./ProfileFeeDisableModal.vue?vue&type=template&id=503bf426"
import script from "./ProfileFeeDisableModal.vue?vue&type=script&lang=js"
export * from "./ProfileFeeDisableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports